// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"fgk-lu","text":"_2y8fpg","checkCircle":"_2EL9dd"};